import React from "react";

const QueueTimeout = () => {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.0002 13C10.4854 13 12.5 10.9854 12.5 8.50017C12.5 6.01498 10.4854 4.00034 8.0002 4.00034C5.51501 4.00034 3.50037 6.01498 3.50037 8.50017C3.50037 10.9854 5.51501 13 8.0002 13Z"
        stroke="#8250DF"
        strokeWidth="0.980392"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.7508 6.75002L8.00012 8.5007"
        stroke="#8250DF"
        strokeWidth="0.980392"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 4.50058L4.50058 3"
        stroke="#8250DF"
        strokeWidth="0.980392"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4998 3L13.0003 4.50058"
        stroke="#8250DF"
        strokeWidth="0.980392"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00012 3.99962L8.00012 3"
        stroke="#8250DF"
        strokeWidth="0.980392"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default QueueTimeout;
